function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ItemsComponent from '../../components/Items/Items';
import { dataItemHover, dataItemHoverOff, dataItemLoad, dataItemsLoad } from '../../store/actions/datasetSlice';
import { getHash, setHash } from '../../utils/urlUtils';
import debounce from 'lodash.debounce';

/**
 * This component is used to provide the list of dataset items that match the current filters and search criteria.
 */
function ItemsContainer(props) {
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      return state.dataset && state.dataset.data;
    }),
    loading = _useSelector.loading,
    error = _useSelector.error,
    items = _useSelector.items,
    info = _useSelector.info;
  var _useSelector2 = useSelector(function (state) {
      return state.dataset && state.dataset.selected;
    }),
    selectedItem = _useSelector2.item;
  var _useSelector3 = useSelector(function (state) {
      return state.dataset && state.dataset.hovered;
    }),
    hoveredItem = _useSelector3.item;

  // const { loading: filtersLoading } = useSelector(
  //   state => state.dataset && state.dataset.filters
  // );

  useEffect(function () {
    var guid = getHash('selectedItem');
    if (guid) {
      dispatch(dataItemLoad({
        guid: guid
      }));
    } else {
      handleSetPage(1);
    }
  }, []);
  var handleSelectItem = function handleSelectItem(guid) {
    setHash('selectedItem', guid);
    dispatch(dataItemLoad({
      guid: guid
    }));
  };
  var handleHover = function handleHover(item, hoverState) {
    if (hoverState === 'on') {
      handleHoverOn(item);
    } else {
      hoveredItem && dispatch(dataItemHoverOff());
    }
  };
  var handleHoverOn = useCallback(debounce(function (item) {
    return dispatch(dataItemHover({
      guid: item.guid,
      interactionType: 'hover'
    }));
  }, 300), []);
  var handleSetPage = function handleSetPage(page) {
    setHash('page', page);
    dispatch(dataItemsLoad({
      page: page
    }));
  };
  return /*#__PURE__*/React.createElement(ItemsComponent, _extends({
    loading: loading,
    error: error,
    items: items,
    selectedItem: selectedItem,
    hoveredItem: hoveredItem,
    info: info,
    setPage: function setPage(page) {
      return handleSetPage(page);
    },
    selectItem: function selectItem(guid) {
      return handleSelectItem(guid);
    },
    hoverItem: function hoverItem(item, hoverState) {
      return handleHover(item, hoverState);
    }
  }, props));
}
ItemsContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A render function that is used to display the a UI based on the provided data and methods.  Either the single function as a child this prop should be provided
   * @function
   * @param {Object} props
   * @param {boolean} props.loading A loading state identifier
   * @param {Object} props.error An error object if any
   * @param {Array} props.items The list of items to matching current search criteria
   * @param {Object} props.selectedItem The currently selectged item if any
   * @param {Object} props.info Information about the current items list
   * @param {Object} props.hoveredItem The currently focused item if any
   * @param {Object} methods
   * @param {function} methods.setPage A method to call when requesting for a specifig page of the items list
   * @param {function} methods.setOrderBy A method to call when applying a different order to the items list
   * @param {function} methods.selectItem A method  to  call  when applying a selection to one of the items
   * @param {function} methods.hoverItem A method to call when applying a focus state to one of the items
   *  */
  render: PropTypes.func
} : {};
export default ItemsContainer;
export var Items = ItemsContainer;